module.exports = {"id":"201976","name":"Alfred Gomis","rating":"74","photo":"./data/images/photos/3/201976.png","club":{"name":"Spal","logo":"./data/images/clubs/Spal.png"},"positions":["G"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlfredGomis0.json
// module id = 281
// module chunks = 0